export function getBackendUrl() {
  return process.env.REACT_APP_CUBE_BACKEND;
}
